import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  dangerousGoodsDetails: [],
  isLoading: false,
  error: "",
  hasData: false
};
const dangerousGoodsSlice = createSlice({
  name: "dangerousGoods",
  initialState,
  reducers: {
    dangerousGoodsDataRequest: state => {
      state.isLoading = true;
    },
    getDangerousGoodsDataSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.dangerousGoodsDetails = action.payload;
    },
    getDangerousGoodsDataFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    }
  }
});
export const {
  dangerousGoodsDataRequest,
  getDangerousGoodsDataSuccess,
  getDangerousGoodsDataFailure
} = dangerousGoodsSlice.actions;
export default dangerousGoodsSlice.reducer;